import { withPlaceholder } from '../../Placeholders';
import { TooltipPlaceholder } from '../../Placeholders/Templates';
import { Tooltip } from '..';

export default withPlaceholder({
    customPlaceholder: TooltipPlaceholder
})(Tooltip);
